import TemplateView from '../TemplateView'

class CreateTasksLightboxHeader extends TemplateView {
    constructor() {
        super(null)
    }

    templateHtml() {
        return '<table class="dialog-header">' +
               '    <tr>' +
               '        <td>' +
               '            <div class="close-button">' +
               '                <div id="closeCreateTasksPopupButton" class="closeCreateTasksPopupButton closeButton"></div>' +
               '                <div class="disabledCloseButton"></div>' +
               '            </div>' +
               '' +
               '            <div class="lightBoxTitle">' +
               '                <%-title%>' +
               '            </div>' +
               '        </td>' +
               '    </tr>' +
               '</table>'
    }

    messageKeys() {
        return {
            title: 'add_new_tasks.title'
        }
    }

    getCloseButtonEl() {
        return this.find('.closeCreateTasksPopupButton')
    }
}

export default CreateTasksLightboxHeader



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTasksLightboxHeader.js